export default "__VITE_ASSET__0831f14a__"